import React from 'react';
import * as Yup from 'yup';

import {
  ApplicationFlow,
  TextInput,
  RadioInputSimple,
} from '../components';
import { documentTypes } from '../data';


const Description = () => (
  <React.Fragment>
    <p>
      A limited liability company (LLC) is a corporate structure whereby the members of the company cannot be held personally liable for the company's debts or liabilities. Limited liability companies are essentially hybrid entities that combine the characteristics of a corporation and a partnership or sole proprietorship.
    </p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Company Information',
    fields: new Map([
      ['orgName', {
        label: 'LLC Name',
        title: 'Please provide a valid corporation name',
        'data-help-title': 'Corporation Name',
        'data-help-text': 'Please enter the name of the corporation.',
        validation: Yup.string().required('Please provide a valid corporation name'),
      }],
      ['dba', {
        'data-help-title': 'Doing Business As (Trade Name)',
        'data-help-text': 'Please enter the trade name of the corporation.',
      }],
      ['llcMembers', {
        component: TextInput,
        initial: 1,
        label: 'Member in LLC',
        validation: (Yup
          .number()
          .integer()
          .moreThan(0)
          .lessThan(1000)
          .required('Please provide the number of LLC members')
        ),
      }],
    ]),
  },
  {
    legend: 'Taxation of the LLC',
    fields: new Map([
      ['taxation', {
        component: RadioInputSimple,
        initial: 'individual',
        options: [
          { value: 'individual', label: 'Individual/Partnership: Not taxed as a separate entity from owner(s).' },
          { value: 's-corporation', label: 'S-Corporation: Planning to elect an S-Corporation tax structure.' },
          { value: 'corporation', label: 'Corporation: LLC is planning to elect a Corporation tax structure.' },
        ],
        validation: Yup.string(),
      }],
    ]),
  },
  {
    legend: 'Owner/Mananging Member Information',
    fields: new Map([
      ['firstName', {
        'data-help-title': 'Managing Member/Owner',
        'data-help-text': 'Managing Member/Owner.',
      }],
      ['middleName', {
        'data-help-title': 'Managing Member/Owner',
        'data-help-text': 'Managing Member/Owner.',
      }],
      ['lastName', {
        'data-help-title': 'Managing Member/Owner',
        'data-help-text': 'Managing Member/Owner.',
      }],
      ['socialSecurity', {
        'data-help-title': 'Managing Member/Owner',
        'data-help-text': 'Managing Member/Owner.',
      }],
      ['verifySocialSecurity', {
        'data-help-title': 'Managing Member/Owner',
        'data-help-text': 'Managing Member/Owner.',
      }],
      ['title', {
        label: 'Business Title',
        placeholder: 'Managing Member/Owner',
        'data-help-title': 'Managing Member/Owner',
        'data-help-text': 'Managing Member/Owner',
      }],
      ['suffix', {
        initial: 'DDS',
      }],
    ]),
  },
  {
    legend: 'Business Address',
    fields: new Map([
      ['businessAddress'],
      ['businessCity'],
      ['businessState'],
      ['businessZip'],
      ['businessCounty'],
      ['mailingAddressDiff'],
    ]),
  },
  {
    legend: 'Business Information',
    fields: new Map([
      ['businessIncCountry'],
      ['businessApplyReason'],
      ['businessActivity'],
      ['businessServices'],
      ['commonQuestionOne'],
      ['commonQuestionTwo'],
      ['commonQuestionThree'],
      ['commonQuestionFour'],
      ['businessAppliedBefore'],
      ['businessHireEmployees'],
    ]),
  },
  {
    legend: 'Business Dates',
    fields: new Map([
      ['businessDateStart'],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail'],
      ['customerContactEmailVerify', {
        label: 'Verify Contact E-mail'
      }],
    ]),
  },
];


const LimitedLiabilityCompanyApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Limited Liability Company Application"
    documentType={documentTypes.LIMITED_LIABILITY_COMPANY}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default LimitedLiabilityCompanyApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/limited-liability-company-application.js